<template>
  <div class="input-group" :class="[containerClass, sizeClass]">
    <input type="text" class="form-control" ref="text" :placeholder="placeholder" :title="toolTip" :readOnly="readOnly" :value="text" :maxlength="maxLengthMassaged" @input="update()" @keyup="eventGeneric('keyup', $event)">
    <div class="input-group-append">
      <b-dropdown :text="currentMatchTypeLabel" :class="[buttonClass]" right>
        <b-dropdown-item @click="matchTypeUpdate('StartsWith')">Starts With [SW]</b-dropdown-item>
        <b-dropdown-item @click="matchTypeUpdate('EndsWith')">Ends With [EW]</b-dropdown-item>
        <b-dropdown-item @click="matchTypeUpdate('Contains')">Contains [CO]</b-dropdown-item>
        <b-dropdown-item @click="matchTypeUpdate('Equals')">Equals [EQ]</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
<script>
  export default {
    name: "generic-text-match-type",
    props: {
      value: String,
      mtValue: String,
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      containerClass: {
        type: String,
        default: ''
      },
      sizeClass: {
        type: String,
        default: ''
      },
      buttonClass: {
        type: String,
        default: 'btn-outline-secondary'
      },
      readOnly: {
        type: Boolean,
        required: false,
        default: false
      },
      toolTip: {
        type: String,
        default: ''
      },
      maxlength: {
        type: Number,
        default: 0
      }
    },
    data() {
      return { 
        text: this.value,
        matchType: this.mtValue
      };
    },
    watch: {
      value: function(val) {
        this.text = val;
      },
      mtValue: function(val) {
        this.matchType = val;
      }
    },
    computed: {
      currentMatchTypeLabel() {
        switch ((this.matchType || 'StartsWith').toLowerCase()) {
          case 'startswith':
            return 'SW';
          case 'endswith':
            return 'EW';
          case 'contains':
            return 'CO';
          case 'equals':
            return 'EQ';
          default:
            return '??';
        }
      },
      maxLengthMassaged() {
        if (this.maxlength && this.maxlength > 0) {
          return this.maxlength;
        }
        return '';
      }
    },
    methods: {
      update(val) {
        if (!this.readOnly) {
          val = val || this.$refs.text.value;
          this.text = val;
          this.$emit('change', this.text);
          this.$emit('input', this.text);
        }
      },
      matchTypeUpdate(newMatchType) {
        if (!this.readOnly) {
          this.matchType = newMatchType;
          this.$emit('mtChange', this.matchType);
          this.$emit('mtInput', this.matchType);
        }
      },
      focus() {
        this.$refs.text.focus();
      },
      eventGeneric(name, event) {
        this.$emit(name, event);
      }
    }
  };
</script>